import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class F163jReclassTriggerService {

  constructor(private http: HttpClient) {}

  saveReclassDetails(
    returnClobSettingsObj: any,
    dataToSend: any[],
    globalService: any,
    GENERAL_CONFIG: any
  ): Observable<any> {
    
    const headers = new HttpHeaders({
      'Accept': 'application/json'
      // DO NOT set Content-Type for FormData!
    });

    // Build request parameters following original service pattern
    const filterParams = globalService?.globalParams?.filterParams || {};
    
    const jsonObj = JSON.stringify(dataToSend);
    const jsonSettings = JSON.stringify(returnClobSettingsObj);
    const isIssueKeyEnabled = globalService?.globalParams?.is_issue_key_enabled;
    const scenarioCode = globalService?.globalParams?.scenarioCode;
    
    let params = filterParams;
    params.combination_key = returnClobSettingsObj.combination_key;
    params = Object.assign({}, globalService?.globalParams || {}, params);
    params = Object.assign({ clob_data: jsonObj }, params);
    params = Object.assign({ clob_settings: jsonSettings }, params);
    params.process_name = "Auto_reclass_163j";
    params.scenarioCode = scenarioCode;
    params.is_issue_key_enabled = isIssueKeyEnabled;

    const baseUrl = GENERAL_CONFIG.base_url;
    const endpoint = `${baseUrl}/saveJsonObject?action_code=ydu4pa`;

    // ✅ Convert requestParams to FormData with proper type handling
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      const value = params[key];
      
      // ✅ Handle different data types properly
      if (value !== null && value !== undefined) {
        if (typeof value === 'object') {
          // Convert objects/arrays to JSON strings
          formData.append(key, JSON.stringify(value));
        } else {
          // Convert primitives to strings
          formData.append(key, String(value));
        }
      }
      // Skip null/undefined values
    });

    return this.http.post<any>(
      endpoint,
      formData,
      { headers: headers }
    );
  }
}